import React from 'react';
import * as PropTypes from 'prop-types';
import Checkbox from '../../Checkbox';
import checkboxStyles from '../../Checkbox/Checkbox.module.css';
import commonStrings from '../../../resources/commonStrings';
import SchoolsChecklist from './SchoolsChecklist';

const propTypes = {
  selectedSchoolBids: PropTypes.array.isRequired,
  onSchoolItemCheck: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  schools: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired, bid: PropTypes.string.isRequired })),
  disabled: PropTypes.bool.isRequired,
};

function SchoolsSelection({ onSchoolItemCheck, selectedSchoolBids, onSelectAll, schools, disabled }) {
  const areAllSchoolsSelected = schools
    ? selectedSchoolBids.length > 0 && selectedSchoolBids.length === schools.length
    : false;
  const areSomeSchoolsSelected = selectedSchoolBids ? selectedSchoolBids.length > 0 && !areAllSchoolsSelected : false;

  return (
    <div className={checkboxStyles['blue']}>
      <Checkbox
        label={commonStrings.recoveryGoalSettingReport.allSchoolsCheckbox}
        checked={areAllSchoolsSelected}
        indeterminate={areSomeSchoolsSelected ? 'true' : undefined}
        onChange={() => {
          onSelectAll(!areAllSchoolsSelected);
        }}
        disabled={schools && schools.length > 0 ? disabled : true}
      />
      <SchoolsChecklist
        schools={schools}
        selectedSchoolBids={selectedSchoolBids}
        onChange={onSchoolItemCheck}
        disabled={disabled}
      />
    </div>
  );
}

SchoolsSelection.propTypes = propTypes;
SchoolsSelection.defaultProps = {
  schools: [],
};
export default SchoolsSelection;
